const GUIDE_STATUSES = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};

export default GUIDE_STATUSES;
